










































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import BaseDataTable from '@/components/BaseDataTable.vue';
import moment from 'moment';
import Auth from '@/connector/Auth.vue';
import BaseDateRangeSearch from '@/components/BaseDateRangeSearch.vue';
import ShareService from '@/services/ShareService';

const shareService = new ShareService();

@Component({
  components: {
    BaseDataTable,
    Auth,
    BaseDateRangeSearch,
  },
})
export default class Share extends Vue {
  public loading: boolean = false;

  public date: string = `${moment().week()}-${moment().year()}`;

  public type: string = '';

  public summary: number = 0;

  // eslint-disable-next-line class-methods-use-this
  get weekOptions() {
    const current = moment();
    const maximumData = moment().subtract(8, 'week');
    const options = [];
    while (current > maximumData) {
      options.push(`${current.week()}-${current.year()}`);
      current.subtract(1, 'week');
    }
    return options;
  }

  // eslint-disable-next-line class-methods-use-this
  get shareUrl() {
    return `${process.env.VUE_APP_API_ENDPOINT}/shares`;
  }

  // eslint-disable-next-line class-methods-use-this
  public getColor(amount: number) {
    if (amount > 0) return 'green';
    return 'red';
  }

  // eslint-disable-next-line class-methods-use-this
  public formatDate(date: string) {
    return moment(date).format('DD/MM/YYYY');
  }

  @Watch('date', { immediate: true })
  // eslint-disable-next-line class-methods-use-this
  async onDateChange(value: string) {
    const { data } = await shareService.getShareSummary(value);
    if (data.shareSummary) {
      this.summary = data.shareSummary;
    }
  }
}
